export class PassengerCount {
    adult: number;
    children: number;
    infants: number;
    total: number;
}